import React, { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { clearLocalStorageOnLogout } from "../helpers/common";
import { isAllowedRedirectUrl } from "../helpers/crossLoginHelper";

const CrossLogoutCallback = () => {
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  const returnUrl = searchParams.get("returnUrl");

  if (!hasProcessed.current) {
    hasProcessed.current = true;

    const referrer = document.referrer;
    if (!referrer || !isAllowedRedirectUrl(referrer)) {
      window.location.href = "/";
      return null;
    }

    clearLocalStorageOnLogout();

    const safeUrl = returnUrl && isAllowedRedirectUrl(returnUrl) ? returnUrl : "/";
    window.location.href = safeUrl;
  }

  return null;
};

export default CrossLogoutCallback;
